import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const statusColor = { paid: "text-green-600", created: "text-amber-600", failed: "text-red-600" };

export function DonationsManager() {
  const [items, setItems] = useState([]);

  useEffect(() => { api.get("/admin/donations").then((res) => setItems(res.data)); }, []);

  const totalPaid = items.filter((i) => i.status === "paid").reduce((s, i) => s + i.amount, 0);

  return (
    <div data-testid="donations-manager">
      <p data-testid="donations-total-paid" className="mb-4 text-sm text-muted-foreground">Total received: <span className="text-foreground font-medium">₹{totalPaid}</span></p>
      <div className="bg-background border border-border divide-y divide-border">
        {items.map((item) => (
          <div key={item.id} data-testid={`donation-row-${item.id}`} className="p-4 flex justify-between items-center">
            <div>
              <p className="font-medium">{item.donor_name} <span className="text-muted-foreground text-sm">· {item.donor_email}</span></p>
              <p className="text-xs text-muted-foreground">{new Date(item.created_at).toLocaleString()}</p>
            </div>
            <div className="text-right">
              <p className="font-heading text-lg">₹{item.amount}</p>
              <p className={`text-xs uppercase font-medium ${statusColor[item.status] || ""}`}>{item.status}</p>
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="p-6 text-muted-foreground text-sm">No donations yet.</p>}
      </div>
    </div>
  );
}
